import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/favorites/contents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/header-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/context/ua-parser.ts");
